const playBtns = document.querySelectorAll<HTMLElement>('.video-inline__play');

const videos = document.querySelectorAll<HTMLElement>('.video-inline');

videos.forEach((video) => {
	const iframe = video.querySelector<HTMLIFrameElement>('iframe');
	if (
		iframe &&
		iframe.src.includes('vimeo') &&
		typeof window.Vimeo !== 'undefined' &&
		window.Vimeo.Player
	) {
		const player = new window.Vimeo.Player(iframe);
		player.on('play', () => {
			iframe.classList.add('playing');
		});
	}
});

playBtns.forEach((playBtn) => {
	playBtn.addEventListener('click', () => {
		const media = playBtn.parentElement;
		if (!media) return;

		media.classList.add('component-media--show-video');

		const video = media.querySelector<HTMLElement>('.video-inline');
		if (!video) return;

		video.classList.add('video-inline--is-visible');
		playBtn.style.display = 'none';

		const iframe = video.querySelector<HTMLIFrameElement>('iframe');
		if (iframe) {
			const videoSrc = iframe.getAttribute('data-src');
			if (videoSrc) {
				iframe.src = videoSrc;
				iframe.classList.add('visible');
			}
		}
	});
});
